/** API_SPEC.md §9 — insights. */
import { api } from './client';
import type { Insights, InsightsSettingsPut } from './types';

export const insightsApi = {
  get: () => api<Insights>('/v1/insights'),
  /** career-compass-metrics ticket 09: saves the given settings, refreshes on
   *  the server and answers with the whole page. 404 while the flag is off. */
  putSettings: (body: InsightsSettingsPut) => api<Insights>('/v1/insights/settings', { method: 'PUT', body }),
  /** Ticket 11: the Weekly review of `weekStart` was shown expanded, so later
   *  opens on any device get one "Last week" line. Idempotent; 204. */
  reviewSeen: (weekStart: string) => api<void>('/v1/insights/review-seen', { method: 'POST', body: { weekStart } }),
};
